import React, { useState } from "react";
import axios from "axios";
import Loader from "./Loader";
import { message } from "antd"; // Import Ant Design message

const Invest = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/auth/send-email`,
        formData
      );

      if (res.data.success) {
        message.success("Meddelandet skickades!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        message.error("Fel vid skickande. Försök igen.");
      }
    } catch (error) {
      console.error("Fel vid skickande:", error);
      message.error("Något gick fel. Försök igen senare.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="invest-space">
      {loading && <Loader />}
      <div className="invest-card">
        <div className="invest-card-sub">
          <div className="invest-card-sub-left">
            <h2 className="invest-card-sub-title">
              Varför välja vårt företag?{" "}
            </h2>
            <p className="virtual-text">
              Det finns många goda skäl till varför du bör anlita oss för din
              renovering i Söder Renovering eller andra byggprojekt. Här är
              några av de främsta anledningarna:
              <br />
              <br />
              Omfattande erfarenhet Vi som arbetar här har lång erfarenhet inom
              bygg- och renoveringsbranschen. Vår gedigna bakgrund gör att vi
              kan hantera projekt av alla slag med hög kompetens och
              effektivitet.
              <br />
              <br />
              Djupgående kunskap Vår erfarenhet har gett oss bred kunskap inom
              alla delar av renovering och byggarbete, oavsett om det gäller
              renovering av ett hem i Söder Renovering eller andra typer av
              byggprojekt.
              <br />
              <br />
              Högsta standard på resultatet Vi vänder oss till dig som
              värdesätter kvalitet och vill ha ett slutresultat som uppfyller de
              högsta kraven på utförande och materialval. Vårt mål är att
              överträffa dina förväntningar varje gång!
            </p>
          </div>
          <div className="invest-card-sub-right">
            <div className="invest-inp-main">
              <div className="invest-inp-main-sub">
                <label className="invest-label">Namn</label>
                <input
                  type="text"
                  className="invest-inp"
                  name="name"
                  placeholder="John"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="invest-inp-main-sub">
                <label className="invest-label">Kontakta</label>
                <input
                  type="text"
                  className="invest-inp"
                  name="phone"
                  placeholder="9876"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="invest-inp-main-sub-post">
              <label className="invest-label">E-post</label>
              <input
                type="text"
                className="invest-inp"
                name="email"
                placeholder="E-post"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="invest-inp-main-sub-post">
              <label className="invest-label">Beskrivning</label>
              <textarea
                name="message"
                className="invest-inp"
                rows="6"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="my-5">
              <button
                className="reg-btn border-0"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Skickar..." : "Gratis offert"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invest;
